import {
  // forms
  AbastecimentoForm,
  AdmSisarePassengerForm,
  AgendaEscalaFornecedorForm,
  CategoriaServicoForm,
  ContaCorrenteForm,
  FechamentoFinanceiroForm,
  FormPax,
  HistoricoBancarioForm,
  MarcaVeiculoForm,
  ModeloVeiculoForm,
  MotivoCancelamentoForm,
  OpcionalVeiculoForm,
  OSForm,
  OsManutVeiculoForm,
  PermissoesForm,
  ServicoForm,
  TipoDocumentoForm,
  TipoVeiculoForm,
  TransacaoFinanceiraForm,
  UsuarioForm,
  UsuarioPartnerForm,
  VeiculoForm,
  VendedorForm,

  // lists
  AbastecimentoList,
  AdmSisarePassengerList,
  AgendaEscalaFornecedorList,
  BancoList,
  CategoriaServicoList,
  ClienteList,
  ContaCorrenteList,
  FechamentoFinanceiroList,
  FeriadoList,
  HistoricoBancarioList,
  MarcaVeiculoList,
  ModeloVeiculoList,
  MotivoCancelamentoList,
  OpcionalVeiculoList,
  OSList,
  OsManutVeiculoList,
  PaisList,
  ServicoList,
  SetorList,
  TipoDocumentoList,
  TipoVeiculoList,
  TransacaoFinanceiraList,
  UsuarioList,
  UsuarioPartnerList,
  VeiculoList,
  VendedorList,

  // outros
  AdmSisarePassengerAnalytics,
  Dashboard,
  FaleConosco,
  Hospedagem,
  Login,
  LoginAppCli,
  LoginPartner,
  Logout,
  MapaOperacao,
  MenuAdministrativo,
  MenuFinanceiro,
  MenuOperacional,
  MenuProducao,
  MenuProgramacao
} from 'views';
import {
  AMODULO_ADMAPPCLI,
  AMODULO_CRM,
  AMODULO_ESTOQUE,
  AMODULO_FINANCAS,
  AMODULO_FRONT,
  AMODULO_FROTAS,
  AMODULO_GERENCIAL,
  AMODULO_PARTNER
} from 'consts';
import {
  Main as MainLayout,
  Minimal as MinimalLayout
} from 'layouts';
import {
  AccountBalanceOutlined,
  AccountCircleOutlined,
  AccountTreeOutlined,
  AssessmentOutlined,
  AssignmentIndOutlined,
  AssignmentOutlined,
  AssignmentTurnedInOutlined,
  BuildOutlined,
  CategoryOutlined,
  ChatBubbleOutlineOutlined,
  Commute,
  DashboardOutlined,
  DescriptionOutlined,
  DriveEtaOutlined,
  EmojiTransportation,
  EventOutlined,
  EventNoteOutlined,
  ExitToAppRounded,
  FormatListBulletedRounded,
  ForumOutlined,
  Grain,
  InsertDriveFileOutlined,
  LocalGasStationOutlined,
  MessageOutlined,
  MonetizationOnOutlined,
  PeopleOutline,
  PermContactCalendarOutlined,
  PersonOutlined,
  PostAddRounded,
  Public,
  QueueOutlined,
  ReceiptOutlined,
  Send,
  SettingsApplicationsOutlined,
  SupervisedUserCircleOutlined,
  TextsmsOutlined,
  Timeline,
  TrendingUpRounded,
  WhatsApp,
  WidgetsOutlined
} from '@material-ui/icons';
import React from 'react';
import { PERMS } from 'permissions';

/* Define as rotas da aplicação, com layout, módulo e permissão de cada uma */
export const appRoutes = [
  // geral
  {
    path: '/login',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/logout',
    exact: true,
    component: Logout,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },

  // adm appcli
  {
    path: '/admappcli',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/admappcli/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admappcli/adm-sisare-passenger/:id',
    exact: true,
    component: AdmSisarePassengerForm,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admappcli/adm-sisare-passenger-list',
    exact: true,
    component: AdmSisarePassengerList,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: PERMS.ADMAPPCLI_MENU_PASSENGER_PASSAGEIRO,
    authType: 'internal'
  },
  {
    path: '/admappcli/adm-sisare-passenger-analytics',
    exact: true,
    component: AdmSisarePassengerAnalytics,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: PERMS.ADMAPPCLI_MENU_PASSENGER_ANALYTICS,
    authType: 'internal'
  },

  // appcli
  {
    path: '/appcli',
    exact: true,
    component: LoginAppCli,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'passenger'
  },
  {
    path: '/appcli/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/login',
    exact: true,
    component: LoginAppCli,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'passenger'
  },
  {
    path: '/appcli/programacao',
    exact: true,
    component: MenuProgramacao,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/hospedagem',
    exact: true,
    component: Hospedagem,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/faleconosco',
    exact: true,
    component: FaleConosco,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/:localizador',
    exact: true,
    component: LoginAppCli,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },

  // adm partner
  {
    path: '/admpartner',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/admpartner/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admpartner/agendaescalafornecedor',
    exact: true,
    component: AgendaEscalaFornecedorList,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA,
    authType: 'internal'
  },
  {
    path: '/admpartner/agendaescalafornecedor/:id',
    component: AgendaEscalaFornecedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA,
    authType: 'internal',
    redirectTo: '/admpartner'
  },
  {
    path: '/admpartner/usuariopartner',
    exact: true,
    component: UsuarioPartnerList,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO_PARTNER,
    authType: 'internal'
  },
  {
    path: '/admpartner/usuariopartner/:id',
    component: UsuarioPartnerForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO_PARTNER,
    authType: 'internal'
  },
  {
    path: '/admpartner/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO,
    authType: 'internal'
  },
  {
    path: '/admpartner/usuario/:id',
    exact: true,
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/admpartner/usuario'
  },
  {
    path: '/admpartner/usuario/:id/permissoes',
    component: PermissoesForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/admpartner/usuario'
  },

  // partner
  {
    path: '/partner',
    exact: true,
    component: LoginPartner,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/partner/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal',
    redirectTo: '/partner'
  },
  {
    path: '/partner/agendaescalafornecedor',
    exact: true,
    component: AgendaEscalaFornecedorList,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA,
    authType: 'partner',
    redirectTo: '/partner'
  },
  {
    path: '/partner/agendaescalafornecedor/:id',
    component: AgendaEscalaFornecedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA,
    authType: 'partner',
    redirectTo: '/partner'
  },

  // crm
  {
    path: '/crm',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/crm/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: 0,
    authType: 'internal'
  },

  // estoque
  {
    path: '/estoque',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/estoque/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_ESTOQUE,
    requiredPerm: 0,
    authType: 'internal'
  },

  // finanças
  {
    path: '/financas',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/financas/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/financas/historicosbancarios',
    exact: true,
    component: HistoricoBancarioList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO,
    authType: 'internal'
  },
  {
    path: '/financas/historicosbancarios/:id',
    exact: true,
    component: HistoricoBancarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO,
    authType: 'internal'
  },
  {
    path: '/financas/historicosbancarios/:id/view',
    exact: true,
    component: HistoricoBancarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO,
    authType: 'internal'
  },
  {
    path: '/financas/tiposdocumentos',
    exact: true,
    component: TipoDocumentoList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO,
    authType: 'internal'
  },
  {
    path: '/financas/tiposdocumentos/:id',
    exact: true,
    component: TipoDocumentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO,
    authType: 'internal'
  },
  {
    path: '/financas/tiposdocumentos/:id/view',
    exact: true,
    component: TipoDocumentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO,
    authType: 'internal'
  },
  {
    path: '/financas/contascorrentes',
    exact: true,
    component: ContaCorrenteList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_CONTA_CORRENTE,
    authType: 'internal'
  },
  {
    path: '/financas/contascorrentes/:id',
    exact: true,
    component: ContaCorrenteForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_CONTA_CORRENTE,
    authType: 'internal'
  },
  {
    path: '/financas/contascorrentes/:id/view',
    exact: true,
    component: ContaCorrenteForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_CONTA_CORRENTE,
    authType: 'internal'
  },
  {
    path: '/financas/transacoes',
    exact: true,
    component: TransacaoFinanceiraList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_TRANSACAO,
    authType: 'internal'
  },
  {
    path: '/financas/bancos',
    exact: true,
    component: BancoList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_BANCO,
    authType: 'internal'
  },
  {
    path: '/financas/setores',
    exact: true,
    component: SetorList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_SETOR,
    authType: 'internal'
  },
  {
    path: '/financas/feriados',
    exact: true,
    component: FeriadoList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_FERIADO,
    authType: 'internal'
  },
  {
    path: '/financas/paises',
    exact: true,
    component: PaisList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_PAIS,
    authType: 'internal'
  },
  {
    path: '/financas/fechamentofinanceiro',
    exact: true,
    component: FechamentoFinanceiroForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_FECHAMENTO_FINANCEIRO_EXECUTAR,
    authType: 'internal'
  },

  // front
  {
    path: '/front',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/front/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/oss',
    exact: true,
    component: OSList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
    authType: 'internal'
  },
  {
    path: '/front/os/:id',
    component: OSForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
    authType: 'internal'
  },
  {
    path: '/front/pax/:id',
    exact: true,
    component: FormPax,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/mapaoperacao', // não tem no desktop, terá somente no web
    exact: true,
    component: MapaOperacao,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/categoriasservicos',
    exact: true,
    component: CategoriaServicoList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_CATEGORIA,
    authType: 'internal'
  },
  {
    path: '/front/categoriasservicos/:id',
    component: CategoriaServicoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_CATEGORIA,
    authType: 'internal'
  },
  {
    path: '/front/servicos',
    exact: true,
    component: ServicoList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_SERVICO,
    authType: 'internal'
  },
  {
    path: '/front/servicos/:id',
    component: ServicoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_SERVICO,
    authType: 'internal'
  },
  {
    path: '/front/motivoscancelamentos',
    exact: true,
    component: MotivoCancelamentoList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_MOTIVO_CANCELAMENTO,
    authType: 'internal'
  },
  {
    path: '/front/motivoscancelamentos/:id',
    component: MotivoCancelamentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_MOTIVO_CANCELAMENTO,
    authType: 'internal'
  },
  {
    path: '/front/vendedores',
    exact: true,
    component: VendedorList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_VENDEDOR,
    authType: 'internal'
  },
  {
    path: '/front/vendedores/:id',
    component: VendedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_VENDEDOR,
    authType: 'internal'
  },
  {
    path: '/front/clientes',
    exact: true,
    component: ClienteList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_CLIENTE_CLIENTE,
    authType: 'internal'
  },
  {
    path: '/front/tipoveiculo',
    exact: true,
    component: TipoVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_VEICULO_TIPO,
    authType: 'internal'
  },
  {
    path: '/front/tipoveiculo/:id',
    component: TipoVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_VEICULO_TIPO,
    authType: 'internal'
  },
  {
    path: '/front/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_USUARIO,
    authType: 'internal'
  },
  {
    path: '/front/usuario/:id',
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/front/usuario'
  },

  // frotas
  {
    path: '/frotas',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/frotas/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/frotas/veiculo',
    exact: true,
    component: VeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/veiculo/:id',
    component: VeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/marcaveiculo',
    exact: true,
    component: MarcaVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MARCA,
    authType: 'internal'
  },
  {
    path: '/frotas/marcaveiculo/:id',
    component: MarcaVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MARCA,
    authType: 'internal'
  },
  {
    path: '/frotas/modeloveiculo',
    exact: true,
    component: ModeloVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MODELO,
    authType: 'internal'
  },
  {
    path: '/frotas/modeloveiculo/:id',
    component: ModeloVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MODELO,
    authType: 'internal'
  },
  {
    path: '/frotas/tipoveiculo',
    exact: true,
    component: TipoVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_TIPO,
    authType: 'internal'
  },
  {
    path: '/frotas/tipoveiculo/:id',
    component: TipoVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_TIPO,
    authType: 'internal'
  },
  {
    path: '/frotas/opcionalveiculo',
    exact: true,
    component: OpcionalVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_OPCIONAL,
    authType: 'internal'
  },
  {
    path: '/frotas/opcionalveiculo/:id',
    component: OpcionalVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_OPCIONAL,
    authType: 'internal'
  },
  {
    path: '/frotas/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_USUARIO,
    authType: 'internal'
  },
  {
    path: '/frotas/usuario/:id',
    exact: true,
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/frotas/usuario'
  },
  {
    path: '/frotas/usuario/:id/permissoes',
    component: PermissoesForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/frotas/usuario'
  },
  {
    path: '/frotas/abastecimento',
    exact: true,
    component: AbastecimentoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_LANCAR,
    authType: 'internal'
  },
  {
    path: '/frotas/abastecimento/:id',
    component: AbastecimentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_LANCAR,
    authType: 'internal'
  },
  {
    path: '/frotas/osmanutveiculo',
    exact: true,
    component: OsManutVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
    authType: 'internal'
  },
  {
    path: '/frotas/osmanutveiculo/:id',
    component: OsManutVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
    authType: 'internal'
  },

  // gerencial
  {
    path: '/gerencial',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/gerencial/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuproducao',
    exact: true,
    component: MenuProducao,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_PRODUCAO,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuoperacional',
    exact: true,
    component: MenuOperacional,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_OPERACIONAL,
    authType: 'internal'
  },
  {
    path: '/gerencial/menufinanceiro',
    exact: true,
    component: MenuFinanceiro,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_FINANCEIRO,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuadministrativo',
    exact: true,
    component: MenuAdministrativo,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_ADMINISTRATIVO,
    authType: 'internal'
  }
];

/* Define os itens de menu exibidos para cada módulo */
export const menuByModule = {
  // adm appcli
  [AMODULO_ADMAPPCLI]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/admappcli/dashboard',
      permCode: 0
    },
    {
      key: 'passageiros',
      labelKey: 'MENU_PASSENGER',
      fallbackLabel: 'Passenger',
      icon: SupervisedUserCircleOutlined,
      children: [
        {
          key: 'adm-sisare-passenger-list',
          labelKey: 'MENU_ITEM_PASSAGEIRO',
          fallbackLabel: 'Passageiros',
          icon: PeopleOutline,
          to: '/admappcli/adm-sisare-passenger-list',
          permCode: PERMS.ADMAPPCLI_MENU_PASSENGER_PASSAGEIRO
        },
        {
          key: 'adm-sisare-passenger-analytics',
          labelKey: 'MENU_ITEM_ANALYTICS',
          fallbackLabel: 'Analytics',
          icon: AssessmentOutlined,
          to: '/admappcli/adm-sisare-passenger-analytics',
          permCode: PERMS.ADMAPPCLI_MENU_PASSENGER_ANALYTICS
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // adm partner
  [AMODULO_PARTNER]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/admpartner/dashboard',
      permCode: 0
    },
    {
      key: 'cadastro',
      labelKey: 'MENU_CADASTRO',
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'agenda',
          labelKey: 'MENU_AGENDA_ESCALA',
          fallbackLabel: 'Agenda Escalas',
          icon: EventNoteOutlined,
          to: '/admpartner/agendaescalafornecedor',
          permCode: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA
        },
        {
          key: 'usuarios-partner',
          labelKey: 'MENU_USUARIO_PARTNER',
          fallbackLabel: 'Usuários Partner',
          icon: AccountCircleOutlined,
          to: '/admpartner/usuariopartner',
          permCode: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO_PARTNER
        },
        {
          key: 'usuarios',
          labelKey: 'MENU_ITEM_USUARIO',
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/admpartner/usuario',
          permCode: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // crm
  [AMODULO_CRM]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/crm/dashboard',
      permCode: 0
    },
    {
      key: 'whatsapp',
      labelKey: 'MENU_WHATSAPP',
      fallbackLabel: 'WhatsApp',
      icon: WhatsApp,
      children: [
        {
          key: 'grupos-msg-whatsapp',
          labelKey: 'MENU_ITEM_WHATSAPP_GRUPO_MENSAGEM',
          fallbackLabel: 'Grupos Mensagens',
          icon: ForumOutlined,
          to: '/crm/grupomsgwhatsappfornecedor',
          permCode: 0
        },
        {
          key: 'msg-whatsapp',
          labelKey: 'MENU_ITEM_WHATSAPP_MENSAGEM',
          fallbackLabel: 'Mensagens',
          icon: MessageOutlined,
          to: '/crm/msgwhatsappfornecedor',
          permCode: 0
        },
        {
          key: 'envio-whatsapp',
          labelKey: 'MENU_ITEM_WHATSAPP_ENVIO',
          fallbackLabel: 'Envio',
          icon: Send,
          to: '/crm/enviowhatsappfornecedor',
          permCode: 0
        },
        {
          key: 'chat-whatsapp',
          labelKey: 'MENU_ITEM_WHATSAPP_CHAT',
          fallbackLabel: 'Chat',
          icon: ChatBubbleOutlineOutlined,
          to: '/crm/chatwhatsapp',
          permCode: 0
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // estoque
  [AMODULO_ESTOQUE]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/estoque/dashboard',
      permCode: 0
    },
    {
      key: 'logout',
      labelKey: 'MENU_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // finanças
  [AMODULO_FINANCAS]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/financas/dashboard',
      permCode: 0
    },
    {
      key: 'cadastro',
      labelKey: 'MENU_CADASTRO',
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'historicos-bancarios',
          labelKey: 'MENU_ITEM_HISTORICO_BANCARIO',
          fallbackLabel: 'Históricos Bancários',
          icon: InsertDriveFileOutlined,
          to: '/financas/historicosbancarios',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO
        },
        {
          key: 'tipos-documentos',
          labelKey: 'MENU_ITEM_TIPO_DOCUMENTO',
          fallbackLabel: 'Tipos Documentos',
          icon: DescriptionOutlined,
          to: '/financas/tiposdocumentos',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO
        },
        {
          key: 'contas-correntes',
          labelKey: 'MENU_ITEM_CONTA_CORRENTE',
          fallbackLabel: 'Contas Correntes',
          icon: TrendingUpRounded,
          to: '/financas/contascorrentes',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_CONTA_CORRENTE
        },
        {
          key: 'transacoes',
          labelKey: 'MENU_ITEM_TRANSACAO',
          fallbackLabel: 'Transações',
          icon: ReceiptOutlined,
          to: '/financas/transacoes',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_TRANSACAO
        },
        {
          key: 'bancos',
          labelKey: 'MENU_ITEM_BANCO',
          fallbackLabel: 'Bancos',
          icon: AccountBalanceOutlined,
          to: '/financas/bancos',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_BANCO
        },
        {
          key: 'setores',
          labelKey: 'MENU_ITEM_SETOR',
          fallbackLabel: 'Setores',
          icon: AccountTreeOutlined,
          to: '/financas/setores',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_SETOR
        },
        {
          key: 'feriados',
          labelKey: 'MENU_ITEM_FERIADO',
          fallbackLabel: 'Feriados',
          icon: EventOutlined,
          to: '/financas/feriados',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_FERIADO
        },
        {
          key: 'paises',
          labelKey: 'MENU_ITEM_PAIS',
          fallbackLabel: 'Países',
          icon: Public,
          to: '/financas/paises',
          permCode: 0
        }
      ]
    },
    {
      key: 'fechamento-financeiro',
      labelKey: 'MENU_FECHAMENTO_FINANCEIRO',
      fallbackLabel: 'Fechamento Financeiro',
      icon: MonetizationOnOutlined,
      children: [
        {
          key: 'executar-fechamento',
          labelKey: 'MENU_ITEM_EXECUTAR_FECHAMENTO',
          fallbackLabel: 'Executar',
          icon: AssignmentTurnedInOutlined,
          to: '/financas/fechamentofinanceiro',
          permCode: PERMS.FINANCAS_MENU_FECHAMENTO_FINANCEIRO_EXECUTAR
        },
        {
          key: 'historico-fechamentos',
          labelKey: 'MENU_ITEM_HISTORICO_FECHAMENTO',
          fallbackLabel: 'Histórico Fechamentos',
          icon: Timeline,
          to: '/financas/fechamentosfinanceiros',
          permCode: 0
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // front
  [AMODULO_FRONT]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/front/dashboard',
      permCode: 0
    },
    {
      key: 'cadastro',
      labelKey: 'MENU_CADASTRO',
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'servicos-root',
          labelKey: 'MENU_ITEM_SERVICO_FRONT',
          fallbackLabel: 'Serviços',
          icon: BuildOutlined,
          children: [
            {
              key: 'categorias-servicos',
              labelKey: 'MENU_ITEM_CATEGORIA_SERVICO_FRONT',
              fallbackLabel: 'Categorias',
              icon: CategoryOutlined,
              to: '/front/categoriasservicos',
              permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_CATEGORIA
            },
            {
              key: 'servicos',
              labelKey: 'MENU_ITEM_SERVICO_FRONT',
              fallbackLabel: 'Serviços',
              icon: BuildOutlined,
              to: '/front/servicos',
              permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_SERVICO
            },
            {
              key: 'motivos-cancelamentos',
              labelKey: 'MENU_ITEM_MOTIVO_CANCELAMENTO',
              fallbackLabel: 'Motivos Cancelamento',
              icon: TextsmsOutlined,
              to: '/front/motivoscancelamentos',
              permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_MOTIVO_CANCELAMENTO
            }
          ]
        },
        {
          key: 'veiculos-root',
          labelKey: 'MENU_ITEM_VEICULO_FRONT',
          fallbackLabel: 'Veículos',
          icon: DriveEtaOutlined,
          children: [
            {
              key: 'tipos-veiculos',
              labelKey: 'MENU_ITEM_TIPO_VEICULO_FRONT',
              fallbackLabel: 'Tipos',
              icon: WidgetsOutlined,
              to: '/front/tipoveiculo',
              permCode: PERMS.FRONT_MENU_CADASTRO_VEICULO_TIPO
            }
          ]
        },
        {
          key: 'clientes-root',
          labelKey: 'MENU_ITEM_CLIENTE',
          fallbackLabel: 'Clientes',
          icon: PeopleOutline,
          children: [
            {
              key: 'clientes',
              labelKey: 'MENU_ITEM_CLIENTE',
              fallbackLabel: 'Cliente',
              icon: PeopleOutline,
              to: '/front/clientes',
              permCode: PERMS.FRONT_MENU_CADASTRO_CLIENTE_CLIENTE
            }
          ]
        },
        {
          key: 'vendedores',
          labelKey: 'MENU_ITEM_VENDEDOR',
          fallbackLabel: 'Vendedores',
          icon: AssignmentIndOutlined,
          to: '/front/vendedores',
          permCode: PERMS.FRONT_MENU_CADASTRO_VENDEDOR
        },
        {
          key: 'usuarios',
          labelKey: 'MENU_ITEM_USUARIO',
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/front/usuario',
          permCode: PERMS.FRONT_MENU_CADASTRO_USUARIO
        }
      ]
    },
    {
      key: 'procedimentos',
      labelKey: 'MENU_PROCEDIMENTOS',
      fallbackLabel: 'Procedimentos',
      icon: FormatListBulletedRounded,
      children: [
        {
          key: 'oss',
          labelKey: 'MENU_ITEM_ORDEM_SERVICO_FRONT',
          fallbackLabel: 'Ordens Serviço',
          to: '/front/oss',
          icon: AssignmentOutlined,
          permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // frotas
  [AMODULO_FROTAS]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/frotas/dashboard'
    },
    {
      key: 'cadastro',
      labelKey: 'MENU_CADASTRO',
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'veiculos-root',
          labelKey: 'MENU_ITEM_VEICULO_FROTAS',
          fallbackLabel: 'Veículos',
          icon: DriveEtaOutlined,
          children: [
            {
              key: 'tipos',
              labelKey: 'MENU_ITEM_TIPO_VEICULO_FROTAS',
              fallbackLabel: 'Tipos',
              icon: WidgetsOutlined,
              to: '/frotas/tipoveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_TIPO
            },
            {
              key: 'veiculos',
              labelKey: 'MENU_ITEM_VEICULO_FROTAS',
              fallbackLabel: 'Veículos',
              icon: DriveEtaOutlined,
              to: '/frotas/veiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_VEICULO
            },
            {
              key: 'marcas',
              labelKey: 'MENU_ITEM_MARCA_VEICULO',
              fallbackLabel: 'Marcas',
              icon: Commute,
              to: '/frotas/marcaveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MARCA
            },
            {
              key: 'modelos',
              labelKey: 'MENU_ITEM_MODELO_VEICULO',
              fallbackLabel: 'Modelos',
              icon: EmojiTransportation,
              to: '/frotas/modeloveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MODELO
            },
            {
              key: 'opcionais',
              labelKey: 'MENU_ITEM_OPCIONAL_VEICULO',
              fallbackLabel: 'Opcionais',
              icon: Grain,
              to: '/frotas/opcionalveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_OPCIONAL
            }
          ]
        },
        {
          key: 'usuarios',
          labelKey: 'MENU_ITEM_USUARIO',
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/frotas/usuario',
          permCode: PERMS.FROTAS_MENU_CADASTRO_USUARIO
        }
      ]
    },
    {
      key: 'procedimentos',
      labelKey: 'MENU_PROCEDIMENTOS',
      fallbackLabel: 'Procedimentos',
      icon: FormatListBulletedRounded,
      children: [
        {
          key: 'abastecimentos-root',
          labelKey: 'MENU_ITEM_ABASTECIMENTO',
          fallbackLabel: 'Abastecimentos',
          icon: LocalGasStationOutlined,
          children: [
            {
              key: 'lancar-abastecimentos',
              labelKey: 'MENU_ITEM_ABASTECIMENTO_LANCAR',
              fallbackLabel: 'Lançar',
              icon: QueueOutlined,
              to: '/frotas/abastecimento',
              permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_LANCAR
            }
          ]
        },
        {
          key: 'oss-manutencao',
          labelKey: 'MENU_ITEM_ORDEM_SERVICO_MANUTENCAO',
          fallbackLabel: 'OS Manutenção',
          icon: AssignmentOutlined,
          to: '/frotas/osmanutveiculo',
          permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ORDEM_SERVICO
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // gerencial
  [AMODULO_GERENCIAL]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/gerencial/dashboard'
    },
    {
      key: 'producao',
      labelKey: 'MENU_PRODUCAO',
      fallbackLabel: 'Produção',
      icon: TrendingUpRounded,
      to: '/gerencial/menuproducao',
      permCode: PERMS.GERENCIAL_MENU_PRODUCAO
    },
    {
      key: 'operacional',
      labelKey: 'MENU_OPERACIONAL',
      fallbackLabel: 'Operacional',
      icon: SettingsApplicationsOutlined,
      to: '/gerencial/menuoperacional',
      permCode: PERMS.GERENCIAL_MENU_OPERACIONAL
    },
    {
      key: 'financeiro',
      labelKey: 'MENU_FINANCEIRO',
      fallbackLabel: 'Financeiro',
      icon: MonetizationOnOutlined,
      to: '/gerencial/menufinanceiro',
      permCode: PERMS.GERENCIAL_MENU_FINANCEIRO
    },
    {
      key: 'administrativo',
      labelKey: 'MENU_ADMINISTRATIVO',
      fallbackLabel: 'Administrativo',
      icon: PermContactCalendarOutlined,
      to: '/gerencial/menuadministrativo',
      permCode: PERMS.GERENCIAL_MENU_ADMINISTRATIVO
    },
    {
      key: 'logout',
      labelKey: 'MENU_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ]
};

/* Helpers opcionais */
// filtra as rotas pertencentes a um módulo específico
export const getRoutesByModule = (moduleCode) => {
  appRoutes.filter(route => route.moduleCode === moduleCode);
};

// retorna os itens de menu de um módulo específico
export const getMenuByModule = (moduleCode) => {
  menuByModule[moduleCode] || [];
};